document.addEventListener("DOMContentLoaded", function () {
    const AT_PRODUCT_TYPE = 'at';
    const UNDER_PRODUCT_TYPE = 'under';
    const { price, productUnderPrice, productAtPrice, freeProductVariants } = window.shipping_insurance;
    const typeEvent = window.free_product_config ? "cart-custom:change" : "cart:change";


    getCartJson()
        .then(response => response.items)
        .then(items => updateInsuranceProduct(items))
        .catch(error => console.log(error));

    let insuranceTimeout;
    ["custom-bundle:add", typeEvent, "cart:refresh"].forEach( eventName => {
        document.addEventListener(eventName, (event) => {
            clearTimeout(insuranceTimeout);
            insuranceTimeout = setTimeout(() => {
                getCartJson()
                    .then(response => response.items)
                    .then(items => updateInsuranceProduct(items))
                    .catch(error => console.log(error));
            }, 400);
        });
    });

    function updateInsuranceProduct(items) {
        const { isDisabled, deleteDisabled } = shippingInsurance();
        const disabledShippingInsurance = isDisabled();
        if (disabledShippingInsurance) return delay(0)


        const produtListId = {
            [AT_PRODUCT_TYPE]: productAtPrice,
            [UNDER_PRODUCT_TYPE]: productUnderPrice
        }

        const mainCartLines = getMainCartLine(items);
        const totalCart = getTotalCart(mainCartLines);

        const typeInsurance = Number(price) <= Number(totalCart) ? AT_PRODUCT_TYPE : UNDER_PRODUCT_TYPE;

        const currentProductId = produtListId[typeInsurance];
        const updateForm = getUpdateForm(typeInsurance, productAtPrice, productUnderPrice);
        const updateEmptyForm = getEmptyForm(items, productAtPrice, productUnderPrice, freeProductVariants);

        let hasInsuranceInCart = false;
        let rightInsuranceQuantity = 0;
        let wrongInsuranceInCart = false;
        let hasFreeProductInCart = false;

        items.forEach(item => {
            if (item.id == productAtPrice) hasInsuranceInCart = true;
            if (item.id == productUnderPrice) hasInsuranceInCart = true;
            
            if (item.id == currentProductId) rightInsuranceQuantity = item.quantity;
            
            if (item.id == productAtPrice && currentProductId != productAtPrice) wrongInsuranceInCart = true;
            if (item.id == productUnderPrice && currentProductId != productUnderPrice) wrongInsuranceInCart = true;
            
            if (freeProductVariants && freeProductVariants.includes(String(item.id))) {
                hasFreeProductInCart = true;
            }
        });

        const shouldClearCart = mainCartLines.length === 0 && (hasInsuranceInCart || hasFreeProductInCart);
        const shouldAddInsurance = mainCartLines.length > 0 && (rightInsuranceQuantity !== 1 || wrongInsuranceInCart);

        if (shouldClearCart) {
            const checkoutBtns = document.querySelectorAll('button[name="checkout"]');
            checkoutBtns.forEach(btn => {
                btn.disabled = true;
                btn.classList.add('is-loading');
            });

            return updateProduct(updateEmptyForm)
                .then(() => {
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    deleteDisabled();
                    checkoutBtns.forEach(btn => {
                        btn.disabled = false;
                        btn.classList.remove('is-loading');
                    });
                })
        }
        
        if (shouldAddInsurance) {
            const checkoutBtns = document.querySelectorAll('button[name="checkout"]');
            checkoutBtns.forEach(btn => {
                btn.disabled = true;
                btn.classList.add('is-loading');
            });

            return updateProduct(updateForm)
                .then(() => {
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    checkoutBtns.forEach(btn => {
                        btn.disabled = false;
                        btn.classList.remove('is-loading');
                    });
                })
        }

        return delay(0)
    }



    function getUpdateForm(typeInsurance, productAtPrice, productUnderPrice) {
        const updateForm = {};
        switch (typeInsurance) {
            case AT_PRODUCT_TYPE:
                updateForm[productAtPrice] = 1;
                updateForm[productUnderPrice] = 0;
                break;
            case UNDER_PRODUCT_TYPE:
                updateForm[productAtPrice] = 0;
                updateForm[productUnderPrice] = 1;
                break;
            default:
                break;
        }
        return updateForm;
    }

    function getEmptyForm(items, productAtPrice, productUnderPrice, freeProductVariants) {
        const updateForm = {};
        updateForm[productAtPrice] = 0;
        updateForm[productUnderPrice] = 0;
        if (freeProductVariants && freeProductVariants.length > 0) {
            items.forEach(item => {
                if (freeProductVariants.includes(String(item.id))) {
                    updateForm[item.key] = 0;
                }
            });
        }
        return updateForm;
    }



    function getMainCartLine(items) {
        const array = [];
        for (let index = 0; index < items.length; index++) {
            const element = items[index];
            const isFreeProduct = freeProductVariants && freeProductVariants.includes(String(element.id));
            if (element.id != productUnderPrice && element.id != productAtPrice && !isFreeProduct) {
                array.push(element)
            }
        }
        return array;
    }

    function getTotalCart(items) {
        return [...items].reduce((accumulator, currentItem) => {
            return accumulator + (currentItem.price * currentItem.quantity)
        }, 0)
    }

    function updateProduct(updates) {
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
        })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    function shippingInsurance() {
        const SHIPPING_INSURANCE_KEY = 'disabled-shipping-insurance';

        return {
            setDisabled: () => sessionStorage.setItem(SHIPPING_INSURANCE_KEY, 'true'),
            isDisabled: () => sessionStorage.getItem(SHIPPING_INSURANCE_KEY) === 'true',
            deleteDisabled: () => sessionStorage.removeItem(SHIPPING_INSURANCE_KEY),
        };
    }

    function getCartJson() {
        return fetch("/cart.js").then(response => response.json());
    };

    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    document.addEventListener("shipping:insurance", () => {
        shippingInsurance().setDisabled()
    });
});
